module.exports = __webpack_public_path__ + "img/friendly-hotel.a3f4ae3d.jpg";